<div class="patient-editing-container">
<section class="patient-editor-wrapper"
         genPermissionSchemaRestrict
         [permissionSchemaKey]="permissionKey"
         (notifyPermissionState)="updateEditableAllow($event)"
>
  <section class="buttons-section">
    <ng-container *ngIf="showEditToolbar">
      <gen-button
        class="button-approve"
        [type]="'quite'"
        [disabled]="!changeApplied"
        [iconClass]="'icon__check'"
        (click)="save()"
      ></gen-button>
    </ng-container>
    <gen-button
      *ngIf="userAllowToEdit && showEditButton"
      [iconClass]="'icon__edit'"
      [type]="'emphasis'"
      [active]="formEditable"
      (click)="editClick()"
    ></gen-button>
  </section>
  <section [ngClass]="{'patientEditingForms':true, 'patient-view-form':editMode}" *ngIf="patient">
    <gen-dynamic-form
      [disabled]="!(userAllowToEdit && formEditable && patientEditingFormEditingStatus)"
      [editMode]="editMode"
      [formData]="patient"
      [formName]="patientDetailsFormId"
      [formVertical]="true"
      [mapAllProperties]="false"
      [notifyDefaultValueInit]="true"
      [overrides]="formOverrides[patientDetailsFormId]"
      [popupMode]="true"
      [resetForm]="resetForm"
      [submitted]="submitted"
      [title]="patientEditingFormTitle"
      [updatedFieldsContextType]="updateContextTypes"
      [updatedFieldsContext]="updateContextSubjects"
      (formChange)="updatePatient($event.form, $event.updated)"
      (resetStatusEmitter)="resetForm = $event"
      (validateChange)="validationArray[0] = $event"
    ></gen-dynamic-form>

    <gen-dynamic-form
      [disabled]="!(userAllowToEdit && formEditable && contactInfoFormEditingStatus)"
      [editMode]="editMode"
      [formData]="patient"
      [formName]="contactInfoFormId"
      [formVertical]="true"
      [mapAllProperties]="false"
      [notifyDefaultValueInit]="true"
      [overrides]="formOverrides[contactInfoFormId]"
      [popupMode]="true"
      [resetForm]="resetForm"
      [submitted]="submitted"
      [title]="contactInfoFormTitle"
      [updatedFieldsContextType]="updateContextTypes"
      [updatedFieldsContext]="updateContextSubjects"
      (formChange)="updatePatient($event.form,$event.updated)"
      (resetStatusEmitter)="resetForm = $event"
      (validateChange)="validationArray[1] = $event"
    ></gen-dynamic-form>

  </section>
</section>

<section class="facilityForm" *ngIf="facilityData.length>0">
  <gen-invalid-tooltip class="invalid-tooltip-wrapper tooltip-position"
    *ngIf="!validationArray[2]"
    [tooltipPlacement]="'right'"
    [tooltipRequired]="true"
    [invalidTooltipText]="facilityConfig.selectOneFacility"
  ></gen-invalid-tooltip>
  <gen-dynamic-form-table
    [tableTitle]="facilityConfig.title"
    [data]="facilityData"
    [formId]="facilityConfig.formId"
    [popupMode]="false"
    [editMode]="true"
    (itemUpdateEmitter)="updateData($event)"
  ></gen-dynamic-form-table>
</section>
</div>
